import { render, staticRenderFns } from "./CentroCustoTabela.vue?vue&type=template&id=89ee37b4&lang=html&"
import script from "./CentroCustoTabela.vue?vue&type=script&lang=js&"
export * from "./CentroCustoTabela.vue?vue&type=script&lang=js&"
import style0 from "../../../../shared-components/generico/Pagination.css?vue&type=style&index=0&lang=css&"
import style1 from "./CentroCustoTabela.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/centro-custo/CentroCustoTabela.vue
// module id = 1118
// module chunks = 28